import React from 'react';
import StaffHeader from './StaffHeader';
import BottomTabs from './components/BottomTabs';

// App layout: header on top, bottom tab bar on mobile, content in between.
export default function StaffShell({ backTo, max = 'max-w-2xl', children }) {
  return (
    <div className="min-h-screen bg-brand-gradient pb-24 lg:pb-10">
      <StaffHeader backTo={backTo} />
      <main className={`${max} mx-auto px-4 sm:px-6 py-6 overflow-x-hidden`}>{children}</main>
      <BottomTabs />
    </div>
  );
}
